import { render, staticRenderFns } from "./SendProposal.vue?vue&type=template&id=31a2f138&scoped=true&"
import script from "./SendProposal.vue?vue&type=script&lang=js&"
export * from "./SendProposal.vue?vue&type=script&lang=js&"
import style0 from "./SendProposal.vue?vue&type=style&index=0&id=31a2f138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2f138",
  null
  
)

export default component.exports